import { defaultTranslations } from '../messages';

export const enTranslations = defaultTranslations;
